var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStackHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "336px",
    height: "353px",
    viewBox: "0 0 336 353",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hello!",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-7",
    transform: "translate(-2291.000000, -1272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2291.961764, 1274.024101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#02-Elements/Sparkles/#11-Copy-2",
    transform: "translate(239.151961, 72.948386) rotate(-42.000000) translate(-239.151961, -72.948386) translate(190.706976, 17.911029)",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 47.4265399,
    x2: 20.9469511,
    y2: 0,
    id: "Border"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.5533716,
    y1: 74.7318954,
    x2: 92.5409327,
    y2: 36.030958,
    id: "Border"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.6555381,
    y1: 108.698436,
    x2: 96.8899711,
    y2: 108.698436,
    id: "Border"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E0E4E7",
    points: "334.410567 146.106963 334.167031 350 123.155818 350 123.041452 146.106963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow",
    fill: "#9BA2A7",
    transform: "translate(78.184984, 216.658434) rotate(-59.000000) translate(-78.184984, -216.658434) ",
    points: "-34.2489806 193.002362 190.618949 193.002362 190.618949 240.314506 -34.2489806 240.314506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.230532,204.578509 L255.541844,204.578509 C259.055183,204.578509 261.903307,207.426633 261.903307,210.939972 L261.903307,215.993505 C261.903307,219.506844 259.055183,222.354968 255.541844,222.354968 L201.230532,222.354968 C197.717193,222.354968 194.869069,219.506844 194.869069,215.993505 L194.869069,210.939972 C194.869069,207.426633 197.717193,204.578509 201.230532,204.578509 Z",
    id: "Dark",
    fill: "#939EAA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStackHolder);
export default __webpack_public_path__ + "static/media/empty-stack-holder.901977a96f22f0a46ce70699bc0c145c.svg";
export { ForwardRef as ReactComponent };